import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';

@Component({
  selector: 'app-editar-curso',
  templateUrl: './editar-curso.component.html',
  styleUrls: ['./editar-curso.component.css']
})
export class EditarCursoComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private shared: RoutingVariablesService,
    private router: Router
  ) { }

  // infomacion del adminstrador:
  token: any;
  usuario: any;
  subscripcionToken: Subscription;
  subscripcionUsuario: Subscription;

  // Si vamos a editar entonces debe tener un id en la ruta
  id = this.route.snapshot.paramMap.get('id');

  // Si vamos a crear id == null

  // auxiliares front
  tipoBusqueda = 'info'

  ngOnInit(): void {
    this.subscripcionToken = this.shared.getToken().subscribe(token => {
      console.log(token)
      if (token.token == 'admin') { console.log('usuario valido') }
      else {
        this.router.navigate(['/']);
        console.log('usuario no valido');
      }
    })
    this.subscripcionUsuario = this.shared.getUsuario().subscribe(usuario => {
      console.log(usuario)
      this.usuario = usuario.usuario;
    })
  }

}
